/** Country code → localized display name for non-Slovak addresses. */
const COUNTRY_NAMES_SK: Record<string, string> = {
  // EU countries
  AT: 'Rakúsko',
  BE: 'Belgicko',
  BG: 'Bulharsko',
  HR: 'Chorvátsko',
  CY: 'Cyprus',
  CZ: 'Česko',
  DK: 'Dánsko',
  EE: 'Estónsko',
  FI: 'Fínsko',
  FR: 'Francúzsko',
  DE: 'Nemecko',
  GR: 'Grécko',
  HU: 'Maďarsko',
  IE: 'Írsko',
  IT: 'Taliansko',
  LV: 'Lotyšsko',
  LT: 'Litva',
  LU: 'Luxembursko',
  MT: 'Malta',
  NL: 'Holandsko',
  PL: 'Poľsko',
  PT: 'Portugalsko',
  RO: 'Rumunsko',
  SI: 'Slovinsko',
  ES: 'Španielsko',
  SE: 'Švédsko',
  // Non-EU European countries
  AL: 'Albánsko',
  AD: 'Andorra',
  IS: 'Island',
  LI: 'Lichtenštajnsko',
  MD: 'Moldavsko',
  MC: 'Monako',
  ME: 'Čierna Hora',
  MK: 'Severné Macedónsko',
  NO: 'Nórsko',
  SM: 'San Maríno',
  RS: 'Srbsko',
  CH: 'Švajčiarsko',
  TR: 'Turecko',
  UA: 'Ukrajina',
  GB: 'Spojené kráľovstvo',
  // Other common countries
  US: 'Spojené štáty',
  CA: 'Kanada',
  AU: 'Austrália',
  NZ: 'Nový Zéland',
  JP: 'Japonsko',
  CN: 'Čína',
  IN: 'India',
  BR: 'Brazília',
  MX: 'Mexiko',
  ZA: 'Juhoafrická republika',
};

const COUNTRY_NAMES_EN: Record<string, string> = {
  // EU countries
  AT: 'Austria',
  BE: 'Belgium',
  BG: 'Bulgaria',
  HR: 'Croatia',
  CY: 'Cyprus',
  CZ: 'Czechia',
  DK: 'Denmark',
  EE: 'Estonia',
  FI: 'Finland',
  FR: 'France',
  DE: 'Germany',
  GR: 'Greece',
  HU: 'Hungary',
  IE: 'Ireland',
  IT: 'Italy',
  LV: 'Latvia',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  MT: 'Malta',
  NL: 'Netherlands',
  PL: 'Poland',
  PT: 'Portugal',
  RO: 'Romania',
  SI: 'Slovenia',
  ES: 'Spain',
  SE: 'Sweden',
  // Non-EU European countries
  AL: 'Albania',
  AD: 'Andorra',
  IS: 'Iceland',
  LI: 'Liechtenstein',
  MD: 'Moldova',
  MC: 'Monaco',
  ME: 'Montenegro',
  MK: 'North Macedonia',
  NO: 'Norway',
  SM: 'San Marino',
  RS: 'Serbia',
  CH: 'Switzerland',
  TR: 'Turkey',
  UA: 'Ukraine',
  GB: 'United Kingdom',
  // Other common countries
  US: 'United States',
  CA: 'Canada',
  AU: 'Australia',
  NZ: 'New Zealand',
  JP: 'Japan',
  CN: 'China',
  IN: 'India',
  BR: 'Brazil',
  MX: 'Mexico',
  ZA: 'South Africa',
};

/** Returns the localized country name for a given ISO code, or the code itself as fallback. */
export function getCountryName(code: string, locale: string): string {
  const map = locale === 'sk' ? COUNTRY_NAMES_SK : COUNTRY_NAMES_EN;
  return map[code] ?? code;
}
